import React, { useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { testSeriesCreate } from "../../../api/TestService";
import { closeModal, ToastMain, SweetAlertShow } from "../../master/Master";
import TestLayout from "./TestLayout";

const ExamTest = () => {
  const [activeTab, setActiveTab] = useState("createSeries");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Series create function
  const createSeries = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const response = await testSeriesCreate(formData);
      if (response?.data?.status) {
        closeModal("Addnew");
        e.target.reset();
        ToastMain.fire({ icon: "success", title: "Created Successfully!" });
      } else {
        if (response?.data?.errors) setError(response?.data?.errors);
        ToastMain.fire({ icon: "info", title: "Something went wrong!" });
      }
    } catch (err) {
      if (err?.response?.data?.errors) setError(err?.response?.data?.errors);
      // ToastMain.fire({ icon: "error", title: err?.response?.data?.message || err?.response?.message || "Something went wrong!" });

      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.response?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  // Tabs cards
  const tabs = [
    {
      id: "createSeries",
      title: "Create Series",
      icon: "fa-solid fa-pen-to-square",
    },
    { id: "seriesList", title: "Series List", icon: "fa-solid fa-list" },
    {
      id: "createExam",
      title: "Create Exam/Test",
      icon: "fa-solid fa-file-circle-plus",
    },
    { id: "examList", title: "Exam/Test List", icon: "fa-solid fa-eye" },
    { id: "result", title: "Result", icon: "fa-solid fa-graduation-cap" },
    { id: "admitCard", title: "Admit Card", icon: "fa-solid fa-id-card" },
    { id: "marksheet", title: "Marksheet", icon: "fa-solid fa-file-lines" },
  ];

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <TestLayout />
                  <div className="col-12">
                    {activeTab === "createSeries" && (
                      <div className="card p-3 shadow-sm">
                        <h5>Create Series</h5>
                        <form onSubmit={createSeries}>
                          <div className="mb-3">
                            <label className="form-label">
                              Test Series Name
                            </label>
                            <input
                              type="text"
                              name="title"
                              className="form-control input-capitalize"
                              required
                            />
                            <span className="text-danger">
                              {error?.title ?? ""}
                            </span>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              Select Series Type
                            </label>
                            <select
                              name="type"
                              className="form-control"
                              required
                            >
                              <option value="">Select Series Type</option>
                              <option value="0">Test</option>
                              <option value="1">Exam</option>
                            </select>
                            <span className="text-danger">
                              {error?.type ?? ""}
                            </span>
                          </div>
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                          >
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExamTest;
